import { clsx } from "clsx";
import { SVGIconProps } from "../interface";
const iconSize: Record<string, string> = {
  8: "h-2",
  12: "h-3",
  16: "h-4",
  24: "h-6",
  32: "h-8",
  40: "h-10",
  48: "h-12",
  56: "h-14",
  80: "h-20",
  124: "h-30",
};
const SvgLivanceIconPrimary = ({
  title,
  titleId,
  size = 16,
  className,
}: SVGIconProps) => {
  const sizeClass = iconSize[size];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 650 650"
      className={clsx(sizeClass, className)}
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="#00658A"
        fillRule="evenodd"
        d="M189.559 460.441V191.663c0-.736 0-1.105.143-1.386a1.32 1.32 0 0 1 .575-.575c.281-.143.65-.143 1.386-.143H397.06c5.155 0 7.733 0 9.702-1.003a9.204 9.204 0 0 0 4.022-4.023c1.003-1.969 1.003-4.546 1.003-9.702v-2.103c0-5.156 0-7.733-1.003-9.702a9.204 9.204 0 0 0-4.022-4.023C404.793 158 402.215 158 397.06 158H185.351c-9.574 0-14.361 0-18.017 1.863a17.093 17.093 0 0 0-7.471 7.471C158 170.99 158 175.777 158 185.351v279.298c0 9.574 0 14.361 1.863 18.017a17.093 17.093 0 0 0 7.471 7.471C170.99 492 175.777 492 185.351 492h279.298c9.574 0 14.361 0 18.017-1.863a17.093 17.093 0 0 0 7.471-7.471C492 479.01 492 474.223 492 464.649V252.94c0-5.155 0-7.733-1.003-9.702a9.204 9.204 0 0 0-4.023-4.022c-1.969-1.003-4.546-1.003-9.702-1.003h-2.104c-5.155 0-7.732 0-9.701 1.003a9.204 9.204 0 0 0-4.023 4.022c-1.003 1.969-1.003 4.547-1.003 9.702v205.397c0 .736 0 1.105-.143 1.386a1.32 1.32 0 0 1-.575.575c-.281.143-.65.143-1.386.143zm270.735 13.05.01-.085zm13.112-13.187.085-.01zm-296.897-.01.084.01zm13.187 13.112.01.085zm0-296.812.01-.085zm-13.187 13.112.085-.01z"
        clipRule="evenodd"
      />
      <path
        fill="#F5AE45"
        fillRule="evenodd"
        d="M463.355 215.292c15.821 0 28.646-12.825 28.646-28.646 0-15.821-12.825-28.646-28.646-28.646-15.821 0-28.646 12.825-28.646 28.646 0 15.821 12.825 28.646 28.646 28.646"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgLivanceIconPrimary;
